import { render, staticRenderFns } from "./GroupButton.vue?vue&type=template&id=2780499f&scoped=true&"
import script from "./GroupButton.vue?vue&type=script&lang=js&"
export * from "./GroupButton.vue?vue&type=script&lang=js&"
import style0 from "./GroupButton.vue?vue&type=style&index=0&id=2780499f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780499f",
  null
  
)

export default component.exports